/**
 * Sysnet API
 *  ## Authorization We use bearer auth throughout the API. Generally, API requests should have the follow header:   {       \"content-type\": \"application/json\",       \"Authorization\": \"Bearer TOKEN_GOES_HERE\"   }   Please refer to the Auth section immediately below for details on getting your token.
 *
 * OpenAPI spec version: 1.0.4
 * Contact: support@hlpos.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Stock object to create a new stock item
 */
export interface ResolveUnknownRequestStock { 
    /**
     * Name of the stock item
     */
    name?: string;
    /**
     * ID of the stock group
     */
    stockGroupId?: number;
    /**
     * Organization reference ID
     */
    orgRefId?: number;
    /**
     * Type of stock item
     */
    type?: string;
    /**
     * Number of inner units per outer package
     */
    innersPerOuter?: number;
}